module.exports = __webpack_public_path__ + "static/media/screenshot4.dcf77350.jpg";